module.exports = __webpack_public_path__ + "img/ad.d19da40.png";